import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'form',
    'select',
    'fieldContainer',
    'fieldsetContainer',
    'resetField',
    'formSendField',
  ]
  initialize() {
    this.hideFields = []
  }
  connect() {
    this.element.controllers = {}
    this.element.controllers['wizard--filter'] = this
    if (window.location.hash) {
      const hash = this.cleanHash(window.location.hash)
      const action = `${this.formTarget.getAttribute('action')}?rst=&form_send=true&${hash}`
      fetch(action)
        .then((response) => response.text())
        .then(() => {
          const urlObj = new URL(window.location.href)
          urlObj.hash = ''
          const url = urlObj.toString()
          window.history.replaceState({}, '', url)
          this.sendForm(false)
        })
        .catch(function (err) {
          console.error(` Err: ${err}`)
        })
    } else {
      this.sendForm(false)
    }
  }
  trimChar(string, charToRemove) {
    while (string.charAt(0) == charToRemove) {
      string = string.substring(1)
    }

    while (string.charAt(string.length - 1) == charToRemove) {
      string = string.substring(0, string.length - 1)
    }

    return string
  }
  cleanHash(hash) {
    hash = this.trimChar(hash, '#')
    hash = `&${hash}`
    const transformZeroValues = {
      '&b=0': '&course_content=',
      '&c=0': '&country=',
      '&d=0': '&city=',
      '&e=0': '&institute=',
      '&f=0': '&course_level=',
      '&g=0': '&course_type=',
      '&h=0': '&course=',
      '&i=0': '&start_date=',
      '&j=0': '&week_count=',
      '&l=0': '&accommodation=',
      '&m=0': '&course_program=',
    }
    Object.entries(transformZeroValues).map((entry) => {
      hash = hash.replaceAll(entry[0], entry[1])
    })
    const transform = {
      '&b=': '&course_content=',
      '&c=': '&country=',
      '&d=': '&city=',
      '&e=': '&institute=',
      '&f=': '&course_level=',
      '&g=': '&course_type=',
      '&h=': '&course=',
      '&i=': '&start_date=',
      '&j=': '&week_count=',
      '&l=': '&accommodation=',
      '&m=': '&course_program=',
    }
    Object.entries(transform).map((entry) => {
      hash = hash.replaceAll(entry[0], entry[1])
    })
    hash = this.trimChar(hash, '&')
    return hash
  }
  selectChangeHandler() {
    this.sendForm(true)
  }
  optionChangeHandler() {
    this.sendForm(true)
  }
  selectOptionHandler(e) {
    e.preventDefault()
    const select = this.selectTargets.find((elem) => elem.name == e.params.field)
    select.value = e.params.id
    select.dispatchEvent(new Event('change'))
  }
  sendForm(formSend) {
    if (formSend) {
      this.formSendFieldTarget.value = true
    }
    this.formTarget.requestSubmit()
  }
  fieldContainerTargetConnected(fieldContainer) {
    if (fieldContainer.dataset.hide === 'True') {
      this.hideFields.push(fieldContainer.dataset.fieldName)
      this.fieldsetContainerTargets.map((elem) => this.showHideFieldsetContainer(elem))
    }
  }
  fieldContainerTargetDisconnected(fieldContainer) {
    if (fieldContainer.dataset.hide === 'True') {
      if (this.hideFields.includes(fieldContainer.dataset.fieldName)) {
        this.hideFields.splice(this.hideFields.indexOf(fieldContainer.dataset.fieldName), 1)
      }
      this.fieldsetContainerTargets.map((elem) => this.showHideFieldsetContainer(elem))
    }
  }
  showHideFieldsetContainer(fieldsetContainer) {
    const fieldNames = JSON.parse(fieldsetContainer.dataset.fieldNames)
    const fields = fieldNames.filter((field) => this.hideFields.includes(field))
    if (fields.length === fieldNames.length) {
      fieldsetContainer.style.display = 'none'
    } else {
      fieldsetContainer.style.display = 'block'
    }
  }
  reset() {
    this.resetFieldTarget.value = 'true'
    this.sendForm(true)
    this.resetFieldTarget.value = null
  }
}
